import { Checkbox } from "@result/rui/components";
import { upperFirst } from "lodash";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import * as LTD from "#/def/lookup-tables.ident.gen";
import { useLookupTableList } from "#/hooks/useLookupTables";

const BreedingValuesTipPvCheckbox = ({
  formField,
  selectionMode = "MULTIPLE",
  autoSelectAll = true,
}) => {
  const { t } = useTranslation();
  const tipiPv = useLookupTableList(LTD.SifPlemVredTipPv);

  useEffect(() => {
    if (
      selectionMode === "MULTIPLE" &&
      autoSelectAll &&
      tipiPv != null &&
      tipiPv.length > 0
    ) {
      formField.setValue(tipiPv.map((t) => t.sifra));
    }
  }, [tipiPv?.length]);

  return (
    <div>
      <div className="label">{t("breedingValues.type")}</div>
      <div className="is-flex is-flex-wrap-wrap is-gap-1">
        {tipiPv?.map((tip) => (
          <Checkbox
            label={`${upperFirst(tip.naziv?.sl?.replace("plemenska vrednost", "PV"))}${tip.naziv?.sl?.toUpperCase()?.startsWith(tip.sifra.toUpperCase()) ? "" : ` (${tip.sifra})`}`}
            onChange={(isChecked) => {
              if (selectionMode === "SINGLE") {
                if (isChecked) {
                  formField.setValue(tip.sifra);
                } else {
                  formField.setValue(null);
                }
              } else {
                const newMethods = [...(formField.value ?? [])];
                if (isChecked) {
                  newMethods.push(tip.sifra);
                } else {
                  newMethods.splice(newMethods.indexOf(tip.sifra), 1);
                }
                formField.setValue(newMethods);
              }
            }}
            isChecked={
              formField.value?.includes(tip.sifra) ||
              formField.value === tip.sifra
            }
            key={tip.sifra}
          />
        ))}
      </div>
    </div>
  );
};

export default BreedingValuesTipPvCheckbox;
